<template>
  <AppDialog
    :loading-confirm-button="loading"
    :show="show"
    :title="t('organization.confirm.create_title')"
    :type="DIALOG_TYPES.INFO"
    :density="DIALOG_DENSITY.COMPACT"
    @on-close="onClose"
    @on-confirm="createOrganization"
  >
    <div>
      {{ t('organization.confirm.create_message') }}
    </div>
  </AppDialog>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import WebAppOrganizationApiHandler from '@/api/web-app-organization'
import { DIALOG_DENSITY, DIALOG_TYPES } from '@/utils/components-configurations/app-dialog'
import { handleError } from '@/utils/error-handling'
import { useReloadPage } from '@/utils/reload-page'

import AppDialog from '@/components/AppDialog'

defineOptions({
  name: 'ConfirmCreateOrganizationModal'
})

defineProps({
  show: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits({
  close: null
})

const { t } = useI18n()

const loading = ref(false)

const { reloadPage } = useReloadPage()

const DEFAULT_ORGANIZATION_NAME = 'Acme Inc'

const createOrganization = async () => {
  loading.value = true
  const api = new WebAppOrganizationApiHandler()

  try {
    const { iss } = await api.createOrganization({ name: DEFAULT_ORGANIZATION_NAME })
    await api.switchOrganization({ iss })
    reloadPage()
  } catch (error) {
    handleError({ error })
  } finally {
    loading.value = false
  }
}

const onClose = () => {
  emit('close')
}
</script>
